<template>
  <v-layout class="lookup-images-container">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="10" md="9" lg="8" class="py-0">
          <v-card elevation="0">
            <v-card-title>Pagos de planes</v-card-title>
            <v-card-text>
              <template>
                <!--<v-toolbar
              class="rounded-toolbar mb-6 white--text overflow-hidden"
              color="#e06f18"
              dense
            >
              <v-toolbar-title class="mr-5">{{
                $t('filters')
              }}</v-toolbar-title>
              <v-row class="fill-height" align="center">
                <v-col cols="auto">
                  <v-select
                    v-model="selectedType"
                    class="no-bottom-border all-white mt-2 white--text hide-placeholder"
                    @change="loadPayments"
                    dark
                    :items="types"
                    hide-details
                    :menu-props="{ offsetY: true }"
                    color="#ffffff"
                    :label="$t('filters.orderTypes')"
                    :placeholder="$t('filters.orderTypes.all')"
                    item-value="id"
                    flat
                    dense
                    item-text="name"
                  ></v-select>
                </v-col>
                <v-col cols="auto">
                  <v-select
                    v-model="selectedStatus"
                    class="no-bottom-border all-white mt-2 white--text"
                    :class="{ 'hide-placeholder': selectedStatus.length }"
                    @change="loadPayments"
                    light
                    :items="status"
                    hide-details
                    :menu-props="{ offsetY: true }"
                    color="#ffffff"
                    :label="$t('filters.status')"
                    multiple
                    :placeholder="$t('filters.status.all')"
                    item-value="id"
                    small-chips
                    flat
                    chips
                    deletable-chips
                    dense
                    item-text="name"
                  ></v-select>
                </v-col>
                <v-col cols="auto">
                  <v-select
                    v-model="selectedTables"
                    class="no-bottom-border all-white mt-2 white--text"
                    :class="{ 'hide-placeholder': selectedTables.length }"
                    @change="loadPayments"
                    light
                    :items="tables"
                    hide-details
                    :menu-props="{ offsetY: true }"
                    color="#ffffff"
                    :label="$t('filters.tables')"
                    multiple
                    :placeholder="$t('filters.tables.all')"
                    item-value="id"
                    small-chips
                    flat
                    chips
                    deletable-chips
                    dense
                    item-text="name"
                  ></v-select>
                </v-col>
              </v-row>
            </v-toolbar>-->
                <template v-if="!payments.length">
                  No se encontraron pagos.
                </template>
                <template v-else>
                  <v-data-table
                    :must-sort="true"
                    :options.sync="options"
                    :headers="headers"
                    :items="payments"
                    :server-items-length="paymentsCount"
                    :items-per-page="options.itemsPerPage"
                    :sort-by="options.sortBy"
                    :sort-desc="options.sortDesc"
                    :calculate-widths="true"
                    @update:options="loadPayments"
                    :dense="true"
                  >
                    <!--<template v-slot:item.table.name="{ item }">
                  <v-chip color="grey" small dark>{{ item.table.name }}</v-chip>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    :color="getStatusColor(item.status)"
                    small
                    label
                    dark
                    >{{ getStatusName(item.status) }}</v-chip
                  >
                </template>
                -->
                    <template v-slot:item.restaurant.picture="{ item }">
                      <v-img
                        class="logo mr-2"
                        :max-width="imgSize"
                        :max-height="imgSize"
                        :width="imgSize"
                        :height="imgSize"
                        style="border-radius: 8px; overflow: hidden"
                        :src="
                          item.logo
                            ? `${uploadsPath}/${item.logo}`
                            : `assets/img/restaurant-logo.png`
                        "
                      ></v-img>
                    </template>

                    <template v-slot:item.restaurant.id="{ item }">
                      <div class="d-flex flex-column col-auto py-0">
                        <div class="children-inline">
                          <h3>{{ item.restaurant.name }}</h3>
                          <span class="font-size-9e grey--text">{{
                            item.restaurant.stringId
                          }}</span>
                          <div class="chips--no-height">
                            <v-chip
                              v-if="isPlanExpired(item.restaurant.planExpiresAt)"
                              label
                              x-small
                              color="red"
                              text-color="white"
                              >Vencido</v-chip
                            >
                            <v-chip
                              v-else-if="getEffectiveTier(item.restaurant) === 0"
                              label
                              x-small
                              color="green"
                              text-color="white"
                              >Lite</v-chip
                            >
                            <v-chip
                              v-else-if="getEffectiveTier(item.restaurant) === 1"
                              label
                              x-small
                              color="orange"
                              text-color="white"
                              >Plus</v-chip
                            >
                            <v-chip
                              v-else
                              label
                              x-small
                              color="#ff6f00"
                              text-color="white"
                              >Pro</v-chip
                            >
                          </div>
                          <v-btn
                            icon
                            x-small
                            :href="`https://${domain}/${item.restaurant.stringId}`"
                            target="_blank"
                            ><v-icon>mdi-link-variant</v-icon></v-btn
                          >
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :color="getPaymentStatusColor(item.status)"
                        small
                        label
                        dark
                        >{{ getPaymentStatusName(item.status) }}</v-chip
                      >
                    </template>
                    <template v-slot:item.total="{ item }">
                      {{ getCurrency(item.currency).symbol }}{{ item.total }}
                    </template>
                    <template v-slot:item.planInfo="{ item }">
                      <div
                        class="d-flex align-center flex-nowrap"
                        v-if="item.data"
                      >
                        <span class="mr-1"
                          >{{ item.data.planDuration }}
                          {{ item.data.planDuration === 1 ? 'mes' : 'meses' }}
                          de</span
                        >
                        <div class="chips--no-height">
                          <v-chip
                            v-if="!item.data.tier"
                            label
                            x-small
                            color="green"
                            text-color="white"
                            >Lite</v-chip
                          >
                          <v-chip
                            v-else-if="item.data.tier === 1"
                            label
                            x-small
                            color="orange"
                            text-color="white"
                            >Plus</v-chip
                          >
                          <v-chip
                            v-else-if="item.data.tier === 2"
                            label
                            x-small
                            color="#ff6f00"
                            text-color="white"
                            >Pro</v-chip
                          >
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.createdAt="{ item }">
                      <timeago
                        :datetime="item.createdAt"
                        :auto-update="60"
                      ></timeago>
                    </template>
                    <!--<template v-slot:item.actions="{ item }">
                  <div class="children-inline">
                    <v-btn
                      @click="view(item)"
                      dark
                      color="blue"
                      small
                      class="ma-1"
                      >{{ $t('view') }}</v-btn
                    >
                  </div>
                </template>-->
                  </v-data-table>
                </template>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import NewItemModal from '../modals/NewItemModal.vue';
  import OrderModal from '../modals/OrderModal.vue';
  import { IRestaurant } from '../../../interfaces/IRestaurant';
  import { IBranch } from '../../../interfaces/IBranch';
  import { PrintPluginStatus } from '../../../modules/PrintService';
  import { Globals } from '../../../modules/Globals';
  import RestaurantsService from '../../../api/services/restaurants.service';
  import TablesService from '../../../api/services/tables.service';
  import { IOrder } from '../../../interfaces/IOrder';
  import { ITable } from '../../../interfaces/ITable';
  import {
    OrderType,
    OrderPaymentStatusColor,
  } from '../../../enums/OrderEnums';
  import { PaymentStatus } from '../../../enums/PaymentEnums';
  import PaymentsService from '../../../api/services/payments.service';
  import { IPayment } from '../../../interfaces/IPayment';
  import { IUser } from '../../../interfaces/IUser';
  import { usePrinting } from '@/composition/use-printing';
  import { getTopLevelDomain } from '@/utils/domain.utils';
  import { getEffectiveTier, isPlanExpired } from '@/utils/billing-entitlements.utils';

  @Component
  export default class RestaurantPayments extends Vue {
    @Prop() user: IUser;
    @Prop() restaurant: IRestaurant;
    @Prop() branch: IBranch;
    isMobile = Globals.isMobile;
    restaurantsService = new RestaurantsService();
    tablesService = new TablesService();
    paymentsService = new PaymentsService();
    payments: IPayment[] = [];
    status = [];
    types = [];
    selectedStatus = [];
    tables: ITable[] = [];
    selectedTables = [];
    selectedType = OrderType.Seat;
    options = {
      itemsPerPage: 10,
      page: 1,
      sortBy: ['createdAt'],
      sortDesc: [true],
    };
    paymentsCount = 0;
    uploadsPath = Globals.uploadsPath;
    imgSize = 50;
    printing = usePrinting();
    domain = getTopLevelDomain();
    getEffectiveTier = getEffectiveTier;
    isPlanExpired = isPlanExpired;

    async created() {
      this.status = [
        { id: 'received', name: this.$tc('order.status.received') },
        { id: 'progress', name: this.$tc('order.status.progress') },
        { id: 'finished', name: this.$tc('order.status.finished') },
        { id: 'readyta', name: this.$tc('order.status.readyta') },
        { id: 'declined', name: this.$tc('order.status.declined') },
        { id: 'canceled', name: this.$tc('order.status.canceled') },
      ];
      this.types = [
        { id: OrderType.Seat, name: this.$tc('order.type.seat') },
        { id: OrderType.Away, name: this.$tc('order.type.away') },
        { id: OrderType.Delivery, name: this.$tc('order.type.delivery') },
      ];
    }

    mounted() {
      this.init();
    }

    @Watch('branch')
    onBranchChanged() {
      this.init();
    }

    get headers() {
      const headers = [];

      headers.push(
        ...[
          { text: '', value: 'restaurant.picture', width: 50 },
          { text: 'Tienda', value: 'restaurant.id' },
          { text: this.$tc('status'), value: 'status' },
          { text: this.$tc('total'), value: 'total' },
          { text: 'Tipo de plan', value: 'planInfo' },
          { text: this.$tc('date'), value: 'createdAt' },
          /*{ text: '', value: 'actions', sortable: false, width: 150 },*/
        ]
      );

      return headers;
    }

    getCurrency(id) {
      return Globals.getCurrency(id);
    }

    async init() {
      await this.loadPayments();
    }

    async loadPayments() {
      const paginated = await this.paymentsService.getAll(this.options);
      this.payments = paginated.items;
      this.paymentsCount = paginated.total;
    }

    getPaymentStatusColor(status: PaymentStatus) {
      return OrderPaymentStatusColor[status] ?? 'grey';
    }

    getPaymentStatusName(status: PaymentStatus) {
      switch (status) {
        case 'await':
        case 'unknown':
          return 'Pendiente';
        case 'paid':
          return 'Exitoso';
        case 'declined':
          return this.$tc('order.paymentStatus.declined');
        case 'reimbursed':
          return this.$tc('order.paymentStatus.reimbursed');
      }
    }

    get printerStatus() {
      return this.printing.status.value;
    }

    get printerConnected() {
      return (
        this.printingEnabled &&
        this.printerStatus === PrintPluginStatus.Connected
      );
    }

    get printingEnabled() {
      return !this.isMobile;
    }

    /*async view(order: IOrder) {
      const fullOrder = await this.paymentsService.getById(order.id);

      this.$modal.show(
        OrderModal,
        {
          order: fullOrder,
          printEnabled: this.printingEnabled && this.printerConnected,
        },
        {
          name: 'view-order',
          classes: 'dialog--height-limit',
          adaptive: true,
          height: 'auto',
          width: 1000,
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          statusChanged: (status: Paymentstatus) => {
            order.status = status;
          },
          paymentStatusChanged: (status: OrderPaymentStatus) => {
            order.paymentStatus = status;
          },
          print: this.printOrder,
        }
      );
    }*/
  }
</script>
